import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ConfirmEmailPage } from '@/features/account';

/** Landing page of the email-change confirmation link; the token is the only credential. */
export const Route = createFileRoute('/(public)/confirm-email')({
  validateSearch: z.object({ token: z.string().optional() }),
  component: ConfirmEmailRoute,
});

function ConfirmEmailRoute() {
  const { token } = Route.useSearch();
  return <ConfirmEmailPage token={token} />;
}
